import { Col } from 'reactstrap';

export function Footer() {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <Col md="12" className="footer-copyright text-center">
            <p className="mb-0">
              Copyright {new Date().getFullYear()} © RCATS — Royal Career &amp; Academic Tracking
              System
            </p>
          </Col>
        </div>
      </div>
    </footer>
  );
}
